<template>
  <div class="info-block asset-block"
       @click.stop.prevent="$parent.displayPreview('video', preview, title)">
      <div class="asset-content video">
          <div class="preview big design">
              <img v-if="icon" class="contain" :src="icon" alt="">
          </div>
        <div v-if="title" class="title" v-html="title"></div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'InfoAssetBlock',
  props: {
    title: {
      type: String,
    },
    icon: {
      type: String,
      default: null,
    },
    preview: {
      type: String,
      default: undefined,
    },
  },
};
</script>
